import React, { FC, useMemo } from "react";
import { useFormatter } from "kw/util/useFormatter";
import { SummaryTable } from "./SummaryTable";
import { useGate } from "statsig-react";

type TCustomerDetailsSection = {
  customer: TCustomer;
};
export const CustomerDetailsSection: FC<TCustomerDetailsSection> = ({ customer }) => {
  const { formatDateTime, formatString, formatBoolean } = useFormatter();

  const { value: isQBE, isLoading } = useGate("qbe_admin");
  const email = () => {
    const ce = formatString(customer?.contactEmail);
    const e = formatString(customer?.email);

    if (e && e.includes("@")) {
      return e;
    }
    if (ce && ce.includes("@")) {
      return ce;
    }

    return "-";
  };

  const customerDetailsData = useMemo(() => {
    const defaultData = [
      {
        id: "id",
        label: "Customer ID",
        value: formatString(customer?.id),
      },
      {
        id: "active",
        label: "Active",
        value: formatBoolean(customer?.isActive),
      },
      {
        id: "name",
        label: "Name",
        value: formatString(
          customer?.fullName?.trim() ||
          `${customer?.firstName ?? ""} ${customer?.lastName ?? ""}`.trim() ||
          "-",
        ),
      },
      {
        id: "username",
        label: "Username",
        value: email(), // TODO customer.email is a UUID -> find out why, and remove, or always alias to contactEmail
      },
      {
        id: "contact-email",
        label: "Contact email",
        value: customer?.contactEmail,
      },
      {
        id: "phone",
        label: "Phone",
        value: formatString(customer?.contactNumber),
      },
      {
        id: "created",
        label: "Created",
        value: formatDateTime(customer?.dateJoined),
      },
      {
        id: "referred",
        label: "Referred by",
        value: formatString(customer?.latestReferrer?.name),
      },
    ];
    const qbeData = [
      {
        id: "id",
        label: "Customer ID",
        value: formatString(customer?.id),
      },
      {
        id: "active",
        label: "Active",
        value: formatBoolean(customer?.isActive),
      },
      {
        id: "name",
        label: "Name",
        value: formatString(
          customer?.fullName?.trim() ||
          `${customer?.firstName ?? ""} ${customer?.lastName ?? ""}`.trim() ||
          "-",
        ),
      },
      {
        id: "phone",
        label: "Phone",
        value: formatString(customer?.contactNumber),
      },
      {
        id: "created",
        label: "Created",
        value: formatDateTime(customer?.dateJoined),
      },
      {
        id: "referred",
        label: "Referred by",
        value: formatString(customer?.latestReferrer?.name),
      },
    ];
    return isQBE ? qbeData : defaultData;
  }, [isQBE]);

  return <SummaryTable data={customerDetailsData} type="CUSTOMER" />;
};
